import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [projectData, setProjectData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const storedToken = localStorage.getItem('magicToken');
    const storedClient = localStorage.getItem('clientData');
    const storedProject = localStorage.getItem('projectData');
    const storedUser = localStorage.getItem('userData');

    if (storedToken) {
      setAuthToken(storedToken);
    }

    try {
      if (storedClient) setClientData(JSON.parse(storedClient));
    } catch {
      localStorage.removeItem('clientData');
    }

    try {
      if (storedProject) setProjectData(JSON.parse(storedProject));
    } catch {
      localStorage.removeItem('projectData');
    }

    try {
      if (storedUser) setUserData(JSON.parse(storedUser));
    } catch {
      localStorage.removeItem('userData');
    }

    setReady(true);
  }, []);

  const login = (token, client = null, project = null, user = null) => {
    setAuthToken(token);
    localStorage.setItem('magicToken', token);

    if (client) {
      setClientData(client);
      localStorage.setItem('clientData', JSON.stringify(client));
    }

    if (project) {
      setProjectData(project);
      localStorage.setItem('projectData', JSON.stringify(project));
    }

    if (user) {
      setUserData(user);
      localStorage.setItem('userData', JSON.stringify(user));
    }
  };

  const logout = () => {
    setAuthToken(null);
    setClientData(null);
    setProjectData(null);
    setUserData(null);
    localStorage.removeItem('magicToken');
    localStorage.removeItem('clientData');
    localStorage.removeItem('projectData');
    localStorage.removeItem('userData');
  };

  const isAuthenticated = !!authToken;

  const contextValue = useMemo(() => ({
    authToken,
    clientData,
    projectData,
    userData,
    login,
    logout,
    ready,
    isAuthenticated,
  }), [authToken, clientData, projectData, userData, ready, isAuthenticated]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);